import dictionary from '../../../../utils/dictionary'

import { PERIPHERAL } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: PERIPHERAL + '/compatible/product',
  relationSearch: true,
  params: {},
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入版本名称',
    moreBtnWidth: 160,
    searchFieldNameArr: ['productVersion'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'left',
        label: 'sk.back',
        action: 'ReturnPage'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '产品版本',
          prop: 'productVersion',
          sortField: 'productVersion'
        }
      },
      {
        props: {
          label: '解决方案',
          prop: 'scheme'
        }
      },
      {
        props: {
          label: '兼容状态',
          prop: 'compatibleStatus',
          sortField: 'compatibleStatus'
        },
        filter: true,
        dataType: 'enum'
      },
      {
        props: {
          label: '兼容说明',
          prop: 'compatibleDesc',
          sortField: 'compatibleDesc'
        }
      },
      {
        props: {
          label: '兼容操作系统',
          prop: 'id',
          sortField: 'id'
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          var showList = []
          for (const iterator of data.osCompatibleList) {
            if (iterator.compatibleStatus === 'NOT_SUPPORTED') {
              continue
            }
            showList.push(iterator)
          }
          var html = []

          if (showList.length == 0) {
            html.push(<div>无</div>)
          }
          for (const iterator of showList) {
            if (iterator.compatibleStatus === 'SUPPORT') {
              html.push(
                <div>
                  <span>{iterator.os}:</span>
                  <el-tag type={dictionary['compatibleStatus'][iterator.compatibleStatus]['type']}>
                    {dictionary['compatibleStatus'][iterator.compatibleStatus]['label']}
                  </el-tag>
                </div>
              )
            }
            if (iterator.compatibleStatus === 'NOT_SUPPORTED' || iterator.compatibleStatus === 'SECTION_SUPPORT') {
              html.push(
                <div>
                  <span>{iterator.os}:</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content={iterator.compatibleDesc}
                    disabled={iterator.compatibleDesc === null || iterator.compatibleDesc === '' ? false : true}
                    placement="top-end"
                  >
                    <el-tag type={dictionary['compatibleStatus'][iterator.compatibleStatus]['type']}>
                      {dictionary['compatibleStatus'][iterator.compatibleStatus]['label']}
                    </el-tag>
                  </el-tooltip>
                </div>
              )
            }
          }
          return html
        }
      },
      {
        props: {
          label: '不兼容操作系统',
          prop: 'manufacturer',
          sortField: 'manufacturer'
        },
        dataType: 'custom',
        custom: function(data, h) {
          if (!data) {
            return
          }
          var showList = []
          for (const iterator of data.osCompatibleList) {
            if (iterator.compatibleStatus !== 'NOT_SUPPORTED') {
              continue
            }
            showList.push(iterator)
          }
          var html = []
          if (showList.length == 0) {
            html.push(<div>无</div>)
          }

          for (const iterator of showList) {
            html.push(
              <div>
                <span>{iterator.os}:</span>
                <el-tag type={dictionary['compatibleStatus'][iterator.compatibleStatus]['type']}>
                  {dictionary['compatibleStatus'][iterator.compatibleStatus]['label']}
                </el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={iterator.compatibleDesc}
                  disabled={iterator.compatibleDesc === null || iterator.compatibleDesc === '' ? false : true}
                  placement="top-end"
                >
                  <div class="el-icon-warning bg-red"></div>
                </el-tooltip>
              </div>
            )
          }
          return html
        }
      }
    ],
    menus: []
  }
}
